'use client';

import React, { Suspense, useState } from 'react';
import styles from '../styles/Home.module.css';
import { auth, fetchUserDetails } from '@/lib/firebase-client';
import { signOut } from 'firebase/auth';
import { decodeString } from '@/lib/client-utils';  




export default function Page() {

  const [userDetails, setUserDetails] = useState<any>(null);

  // Fetch user details when component mounts
  React.useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = auth.currentUser;
        console.log('User:', user);
        if (user) {
          const details = await fetchUserDetails(user.uid);
          setUserDetails(details);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUser();
  }, []);

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <img src="https://edutechs.app/assets/images/logoLight-NoBackground.png" alt="Edutechs Logo" width="140" height="35" />
          <h2>
            Video Conferencing for Teachers & Students
          </h2>
        </div>
        <Suspense fallback="Loading">
            {/* User Info Top Element */}
            {userDetails && (
                <div style={{
                  position: 'absolute',
                  top: '2rem',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  gap: '0.75rem',
                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  backdropFilter: 'blur(10px)',
                  padding: '0.75rem 1rem',
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                  maxWidth: '350px',
                  width: '100%',
                  zIndex: 10
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        width: '100%'
                    }}>
                        {/* User Avatar */}
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#0077d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '1.2rem',
                            fontWeight: '600',
                            flexShrink: 0
                        }}>
                            {decodeString(userDetails.UserName)?.charAt(0)?.toUpperCase() || 'U'}
                        </div>
                        
                        {/* User Email */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.25rem',
                            minWidth: 0,
                            flex: 1
                        }}>
                            <div style={{
                            color: 'white',
                            fontSize: '0.9rem',
                            fontWeight: '500',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                            }}>
                            {decodeString(userDetails.UserName) || 'User'}
                            </div>
                            <div style={{
                            color: 'rgba(255, 255, 255, 0.7)',
                            fontSize: '0.8rem',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                            }}>
                            {decodeString(userDetails.UserEmail) || 'user@example.com'}
                            </div>
                        </div>
                    </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: '0.5rem',
                    width: '100%'
                  }}>


                    
                    {/* Sign Out Button */}
                    <button
                      onClick={async () => {
                        await signOut(auth);
                        window.location.reload();
                      }}
                      style={{
                        background: 'rgba(255, 255, 255, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        borderRadius: '6px',
                        color: 'white',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        padding: '0.4rem 0.8rem',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.3rem'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                      }}
                    >
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                        <polyline points="16,17 21,12 16,7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                      </svg>
                      Sign Out
                    </button>
                  </div>
                </div>
              )}
            {/* <DemoMeetingTab label="Demo" /> */}
        </Suspense>
      </main>
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <p className={styles.footerText}>
            © 2024 Edutechs. All rights reserved. | Video Conferencing for Teachers & Students
          </p>
        </div>
      </footer>
    </>
  );
}
